import * as yup from "yup";

export const subscriptionSchema = yup.object().shape({
	name: yup.string().required("Name is required"),
	price: yup
		.string()
		.required("Price is required")
		.matches(/^\d*\.?\d+$/, "Price should be a positive number"),
	billing_period: yup
		.string()
		.required("Billing interval is required")
		.matches(/^\d*\.?\d+$/, "Billing interval should be a number"),
	features: yup.array().required("Minimum 3 features are required"),
});
export const configSubscriptionSchema = yup.object().shape({
	max_usage_limit_monthly: yup
		.number()
		.required("Maximum attempts per month is required")
		.min(1, "Maximum attempts per month must be greater than 0"),
	max_allowed_for_auto_gifting: yup
		.number()
		.required("Minimum recipients for admin approval is required")
		.min(1, "Minimum recipients for admin approval must be greater than 0"),
	max_recipients_limit: yup
		.number()
		.required("Maximum allowed recipients per attempt is required")
		.min(1, "Maximum allowed recipients per attempt must be greater than 0"),
	min_referred_users: yup
		.number()
		.required("Minimum referred users for claiming promo gifts is required"),
});
